import { Component } from 'react';
import PanelComponent from '../shared_components/PanelComponent';

class DisclaimerComponent extends Component {

  render() {
    return (
      <PanelComponent classNames="row disclaimer" show>
        <h3>Uitgangspunten:</h3>
        <h4>Maandlasten</h4>
        <p>
          In de (voorbeeld)berekeningen en vergelijkingen wordt het verschil in rentelasten weergegeven.
          Hierbij worden de aflossing en eventuele overlijdensrisicopremie buiten beschouwing gelaten.
          De aflossing komt wel terug in het maandlasten overzicht wanneer er een berekening wordt gemaakt.
        </p>

        <h4>Hypotheekrente & rentevaste periode</h4>
        <p>
          Er is voor de hele looptijd van de hypotheek gerekend met het rentepercentage van de gekozen rentevaste
          periode. Na de rentevaste periode kan het rentepercentage in werkelijkheid anders zijn.
        </p>

        <h4>Aanbieders zonder looptijdrente</h4>
        <p>
          In vergelijkingen met aanbieders die geen looptijdrente hanteren is de aanname gedaan dat de gekozen rente
          gedurende de rentevaste periode gelijk blijft. Bij het einde van de rentevaste periode wordt de rente
          aangepast naar de risicoklasse die hoort bij de schuld-marktwaardeverhouding van dat moment (op basis van de
          periodieke aflossing). Voor de gehele looptijd van de hypotheek (veelal 30 jaar) wordt de oorspronkelijke
          rentevaste periode gehanteerd (bijvoorbeeld: als gekozen wordt voor een rentevaste periode van 5 jaar dan
          wordt elke 5 jaar de rente aangepast naar de risicoklasse die hoort bij de schuld-marktwaarde verhouding van
          dat moment).
        </p>

        <h4>Hypotheken met Nationale Hypotheekgarantie(NHG)</h4>
        <p>
          Bij een hypotheek met NHG zal de looptijdrente in de meeste gevallen niet wijzigen ten opzichte
          van de aanvangsrente. Een enkele geldverstrekker hanteert ook risicoklassen bij hypotheken met NHG.
        </p>

        <h4>Aflossingsvrije deelleningen</h4>
        <p>
          Bij een aflossingsvrije deellening gaan we ervan uit dat deze deellening aan het einde van de looptijd in zijn
          geheel wordt afgelost (ook als er andere deelleningen zijn die een langere looptijd hebben).
        </p>
      </PanelComponent>
    );
  }
}

export default DisclaimerComponent;
